import React from 'react'
import {connect} from 'react-redux'

import {
  MESSAGE_APPROVAL_STATUSES
} from '../config/constants'

import {watchMessage, unwatchMessage} from '../data/watchers/message'
import isUserModerator from '../data/helpers/is_user_moderator'
import isUserAllowedToSeeModeratedMessage from '../data/helpers/is_user_allowed_to_see_moderated_message'

import MessageApprovalActions from './message_approval_actions'
import RichMediaContainer from '../containers/rich_media_container'

class ModeratedMessageItem extends React.Component {
  constructor (props) {
    super(props)

    this.state = {}
  }

  componentWillMount () {
    if (this.props.containerId && this.props.message) {
      this.props.onComponentLoaded(this.props.containerId, this.props.message.get('key'))
    }
  }

  componentWillUnmount () {
    this.props.onComponentUnLoaded(this.props.containerId, this.props.message.get('key'))
  }

  getDominantBubbleColor () {
    return (
      this.props.side === 'receiver'
        ? this.props.receiverBubbleBackgroundColor
        : this.props.senderBubbleBackgroundColor
    )
  }

  classNames () {
    let classes = 'message-item moderated'

    const approvalStatus = this.props.message.get('approvalStatus')
    const {INITIAL, DECLINED} = MESSAGE_APPROVAL_STATUSES

    if (approvalStatus === INITIAL) classes += ' approval-waiting'
    else if (approvalStatus === DECLINED) classes += ' approval-declined'

    return classes
  }

  renderRichMessage () {
    return (
      <RichMediaContainer
        isHidden={this.props.isHidden}
        content={this.props.message.get('message')}
        onHeightChange={this.props.onMessageItemHeightChange}/>
    )
  }

  renderSimpleMessage () {
    return this.props.message.get('message')
  }

  renderMessage () {
    if (this.props.isRichMessageContentEnabled) {
      return this.renderRichMessage()
    }
    else {
      return this.renderSimpleMessage()
    }
  }

  renderApprovalActions () {
    const isModerator = isUserModerator(this.props.currentUserRole)

    if (!isModerator) return false
    if (this.props.side === 'receiver') return false

    return (
      <MessageApprovalActions
        containerId={this.props.containerId}
        messageId={this.props.message.get('key')}/>
    )
  }

  render () {
    if (!isUserAllowedToSeeModeratedMessage(
      this.props.message.get('from'), this.props.currentUserUid,
      this.props.message.get('approvalStatus'), this.props.currentUserRole
    )) return false

    return (
      <div className={this.classNames()}>
        <div className="chat-bubble" style={{color: this.props.textColor, backgroundColor: this.getDominantBubbleColor(), maxWidth: '100%'}}>
          <div className='triangle' style={{borderTopColor: this.getDominantBubbleColor(), visibility: (this.props.shouldShowTriangle ? 'visible' : 'hidden')}} />
          {this.renderMessage()}
          {this.renderApprovalActions()}
        </div>
      </div>
    )
  }
}

ModeratedMessageItem.defaultProps = {
  isRichMessageContentEnabled: true,
  shouldShowTriangle: false
}

const mapStateToProps = (state) => {
  return {
    currentUserUid: state.getIn(['currentUser', 'uid']),
    currentUserRole: state.getIn(['currentUser', 'role']),
    textColor: state.getIn(['chatSettings', 'colors', 'conversation', 'messageColor']),
    senderBubbleBackgroundColor: state.getIn(['chatSettings', 'colors', 'conversation', 'senderBubbleBackground']),
    receiverBubbleBackgroundColor: state.getIn(['chatSettings', 'colors', 'conversation', 'receiverBubbleBackground'])
  }
}

const mapDispatchToProps = () => {
  return {
    onComponentLoaded: watchMessage,
    onComponentUnLoaded: unwatchMessage
  }
}

const ModeratedMessageItemContainer = connect(
  mapStateToProps, mapDispatchToProps
)(ModeratedMessageItem)

export default ModeratedMessageItemContainer



/** WEBPACK FOOTER **
 ** ./modules/shared/conversation/moderated_message_item.js
 **/